import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FeatureCheckbox from 'components/custom/FeatureCheckbox/index'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

class Feature extends Component{
  static propTypes = {
    values: PropTypes.array.isRequired,
    onChangeSelection: PropTypes.func.isRequired
  }

  render() {
    const {
      values,
      onChangeSelection,
    } = this.props

    return (
      <FeatureCheckbox
        values = {values}
        onChangeSelection={onChangeSelection}
      />
    )
  }
}

export default CSSModules(styles, Feature)
